module.exports = "/static/Images/pt-br/Six.png";